import { useParams } from 'react-router-dom'
import { SellerSettings as SellerSettingsComponent } from 'components/sellers/SellerSettings/SellerSettings'

export const SellerSettings: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <SellerSettingsComponent sellerId={id as string} />
}
